import React, { useEffect, useState } from "react";
import PubSub from "pubsub-js";
import { useTranslation } from "react-i18next";
import { Card, Col, Row } from "antd";

import { ViewSelector } from "../../../Common/ViewSelector";
import { IDataTableColumn } from "../../../../types/DataTable.types";
import { DeleteRowTool } from "../../../Common/DataTableToolBox/DeleteRowTool";
import { ToolBoxSearch } from "../../../Common/DataTableToolBox/ToolBoxSearch";
import { ToolBoxCommonActions } from "../../../Common/DataTableToolBox/ToolBoxCommonActions";
import { ToolBoxColumnSelector } from "../../../Common/DataTableToolBox/ToolBoxColumnSelector";
import { MissingTargetRedirectsReportRowTool } from "./MissingTargetRedirectsReportRowTool";

import {
  WEBSITE_CONTENT_PAGES_VIEWS_ADMIN,
  WEBSITE_CONTENT_PAGES_VIEWS_EDITOR,
} from "../../../../constants/innerViews";
import { TRANSLATION_KEY } from "../../../../constants/commonConstants";
import { DATA_TABLE_ROW_SELECTION_CHANGED } from "../../../../constants/pubSubKeys";
import {
  REDIRECTS_DATATABLE_SETTINGS,
  SETTINGS_DATA_TABLE_VISIBLE_COLUMNS_REDIRECTS_KEY,
} from "../../../../constants/redirectsConstants";
import CommonMethods from "../../../../utils/commonMethods";

interface IRedirectsToolBoxProps {
  dataTableColumns: IDataTableColumn[];
}

export const RedirectsToolBox: React.FC<IRedirectsToolBoxProps> = ({
  dataTableColumns,
}) => {
  const { t } = useTranslation([TRANSLATION_KEY.toString()]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<number[]>([]);

  useEffect(() => {
    let rowSelectionPubSub = PubSub.subscribe(
      DATA_TABLE_ROW_SELECTION_CHANGED,
      (msg: string, selectedRowKeys: number[]) => {
        setSelectedRowKeys(selectedRowKeys);
      }
    );
    return () => {
      PubSub.unsubscribe(rowSelectionPubSub);
    };
  }, []);

  return (
    <Card title={t("webSiteContent-pages-redirects-tableName")}>
      <p>{t("webSiteContent-pages-redirects-tableDescription")}</p>

      {selectedRowKeys.length > 0 && (
        <p>
          {t("dataTable-selected")} <strong>{selectedRowKeys.length}</strong>{" "}
          {t("dataTable-items")}
        </p>
      )}

      <Row gutter={[16, 16]}>
        <Col span={24}>
          <ToolBoxSearch dataTableColumns={dataTableColumns} />
        </Col>
        <Col span={24}>
          <ToolBoxCommonActions isShowCopy={false} />
          <DeleteRowTool
            className="mt-13-px"
            selectedRowKeys={selectedRowKeys}
            dataEndpoint={REDIRECTS_DATATABLE_SETTINGS.dataEndpoint}
          />
          <MissingTargetRedirectsReportRowTool className="mt-13-px" />
        </Col>

        <Col span={24}>
          {CommonMethods.IsAdminUser() ? (
            <ViewSelector views={WEBSITE_CONTENT_PAGES_VIEWS_ADMIN} />
          ) : (
            <ViewSelector views={WEBSITE_CONTENT_PAGES_VIEWS_EDITOR} />
          )}
        </Col>
      </Row>

      <ToolBoxColumnSelector
        dataTableColumns={dataTableColumns}
        settingsKey={SETTINGS_DATA_TABLE_VISIBLE_COLUMNS_REDIRECTS_KEY}
      />
    </Card>
  );
};
